import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import api from '../../Utils/Axios';

const HospitalDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const resolveHospitalLogo = (logo) => logo || 'https://api.dicebear.com/9.x/shapes/svg?seed=HospitalDetail';

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const res = await api.get(`/api/admin/hospitals/${id}`);
      setData(res.data);
    } catch (err) {
      toast.error(err?.response?.data?.message || 'Failed to load hospital details');
    } finally {
      setLoading(false);
    }
  }, [id]);

  useEffect(() => {
    load();
  }, [load]);

  const verifyHospital = async () => {
    try {
      await api.patch(`/api/admin/hospitals/${id}/verify`);
      toast.success('Hospital verified');
      load();
    } catch (err) {
      toast.error(err?.response?.data?.message || 'Failed to verify hospital');
    }
  };

  const deleteHospital = async () => {
    const ok = window.confirm('Delete this hospital? This action is permanent.');
    if (!ok) return;

    try {
      await api.delete(`/api/admin/hospitals/${id}`);
      toast.success('Hospital deleted');
      navigate('/hospital-listing');
    } catch (err) {
      toast.error(err?.response?.data?.message || 'Failed to delete hospital');
    }
  };

  if (loading) return <div className="col-lg-12">Loading hospital details...</div>;
  if (!data?.hospital) return <div className="col-lg-12">Hospital not found.</div>;

  const hospital = data.hospital;
  const jobs = data.jobs || [];

  return (
    <div className="col-lg-12">
      <div className="dashboard-inner">
        <div className="author-and-action-btn-area two mb-40">
          <div className="author-area two">
            <div className="author-img">
              <img src={resolveHospitalLogo(hospital.logo)} alt={hospital.name} />
            </div>
            <div className="author-content">
              <span>Hospital Detail</span>
              <h4>{hospital.name}</h4>
              <p>{hospital.email}</p>
            </div>
          </div>
          <div className="action-btn-group">
            {!hospital.isVerified && (
              <button className="primry-btn-2" onClick={verifyHospital}>
                Verify Hospital
              </button>
            )}
            <button className="primry-btn-1" onClick={deleteHospital}>
              Delete Hospital
            </button>
          </div>
        </div>

        <div className="row g-4 mb-40">
          <div className="col-lg-4 col-md-6">
            <div className="counter-single">
              <div className="coundown">
                <p>Status</p>
                <h3>{hospital.isVerified ? 'Verified' : 'Pending'}</h3>
              </div>
            </div>
          </div>
          <div className="col-lg-4 col-md-6">
            <div className="counter-single two">
              <div className="coundown">
                <p>State / City</p>
                <h3>{hospital.state || '-'} / {hospital.city || '-'}</h3>
              </div>
            </div>
          </div>
          <div className="col-lg-4 col-md-6">
            <div className="counter-single three">
              <div className="coundown">
                <p>Posted Jobs</p>
                <h3>{jobs.length}</h3>
              </div>
            </div>
          </div>
        </div>

        <div className="table-wrapper2">
          <div className="title-and-btn">
            <div className="title">
              <h4>Recent Jobs by This Hospital</h4>
            </div>
          </div>
          <table className="eg-table table job-list-table mb-0">
            <thead>
              <tr>
                <th>Title</th>
                <th>Category</th>
                <th>Status</th>
                <th>Billing</th>
                <th>Cost</th>
              </tr>
            </thead>
            <tbody>
              {jobs.length === 0 ? (
                <tr>
                  <td colSpan="5">No jobs posted by this hospital.</td>
                </tr>
              ) : (
                jobs.map((job) => (
                  <tr key={job._id}>
                    <td>{job.title}</td>
                    <td>{job.category || '-'}</td>
                    <td>{job.status}</td>
                    <td>{job.billingType || '-'}</td>
                    <td>${job.postCost || 0}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default HospitalDetail;
